/** Slug de produto e de página do CMS: letras, números e hífen (o que o painel gera). O resto não chega à API. */
export const isSlug = (value: string): boolean => /^[a-z0-9-]+$/i.test(value)
